<h1 class="text-center mb-4 font-semibold">
  Constellation (2019)
</h1>
<div id="albumPreview"></div>

<p class="text-center mb-4" [innerHTML]="'HOME.CONSTELLATION' | translate"></p>

<p class="text-center" [innerHTML]="'HOME.CONTENT' | translate"></p>
